module.exports = __webpack_public_path__ + "static/media/mobile834.f8a1263c.png";